// Import global styles from @garmin/insignia module
@import './node_modules/@garmin/insignia/sass/standard/index.scss';

// Override global style on syntax highlighted code blocks
/* stylelint-disable
selector-attribute-operator-space-before,
selector-attribute-operator-space-after */

code[class^='language-'] {
  background: none;
  border: none;
}
